import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { HandlerService } from '../../services/handler/handler.service';

export interface ChangelogEntry {
  id: number;
  fecha: Date;
  fechaFormateada: string;
  mes: string;
  anio: number;
  periodo: string;
  titulo: string;
  cambios: string;
  cambiosHtml?: SafeHtml;
}

@Component({
  selector: 'app-changelog',
  templateUrl: './changelog.component.html',
  styleUrls: ['./changelog.component.scss']
})
export class ChangelogComponent implements OnInit {

  changelogEntries: ChangelogEntry[] = [];
  selectedEntry: ChangelogEntry | null = null;
  loading: boolean = false;

  itemsPerPage: number = 6;
  currentPage: number = 1;
  totalPages: number = 1;

  constructor(
    private handlerService: HandlerService,
    private sanitizer: DomSanitizer,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.loadChangelogData();
  }

  private loadChangelogData(): void {
    this.loading = true;

    const params = { request: JSON.stringify({ pProceso: 'getChangelog' }) };

    this.handlerService.getData(params).subscribe({
      next: (res: any) => {
        if (res?.result === 1 && res?.data?.items) {
          this.changelogEntries = res.data.items.map((item: any) => {
            const fecha = new Date(item.FECHA + 'T12:00:00');
            const mes = this.getMonthName(fecha.getMonth());
            const anio = fecha.getFullYear();

            return {
              id: item.ID,
              fecha: fecha,
              fechaFormateada: fecha.toLocaleDateString('es-AR'),
              mes: mes,
              anio: anio,
              periodo: `${mes} ${anio}`,
              titulo: item.TITULO,
              cambios: item.CAMBIOS,
              cambiosHtml: this.sanitizer.bypassSecurityTrustHtml(item.CAMBIOS)
            };
          });

          this.changelogEntries.sort((a, b) => b.fecha.getTime() - a.fecha.getTime());
          this.calculatePagination();

          if (this.changelogEntries.length > 0) {
            this.selectEntry(this.changelogEntries[0]);
          }
        }
        this.loading = false;
        this.cdr.detectChanges();
      },
      error: (err) => {
        console.error('Error al cargar changelog:', err);
        this.loading = false;
        this.cdr.detectChanges();
      }
    });
  }

  private calculatePagination(): void {
    this.totalPages = Math.ceil(this.changelogEntries.length / this.itemsPerPage);
  }

  private getMonthName(month: number): string {
    const months = [
      'Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio',
      'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'
    ];
    return months[month];
  }

  selectEntry(entry: ChangelogEntry): void {
    this.selectedEntry = entry;
  }

  isSelectedEntry(entry: ChangelogEntry): boolean {
    return this.selectedEntry?.id === entry.id;
  }

  trackById(index: number, item: ChangelogEntry): number {
    return item.id;
  }

  getChangesCount(entry: ChangelogEntry): number {
    if (!entry.cambios) return 0;
    const liMatches = entry.cambios.match(/<li>/g);
    return liMatches ? liMatches.length : 1;
  }

  get paginatedEntries(): ChangelogEntry[] {
    const startIndex = (this.currentPage - 1) * this.itemsPerPage;
    return this.changelogEntries.slice(startIndex, startIndex + this.itemsPerPage);
  }

  previousPage(): void {
    if (this.currentPage > 1) {
      this.currentPage--;
    }
  }

  nextPage(): void {
    if (this.currentPage < this.totalPages) {
      this.currentPage++;
    }
  }

  get hasPreviousPage(): boolean {
    return this.currentPage > 1;
  }

  get hasNextPage(): boolean {
    return this.currentPage < this.totalPages;
  }
}
